import { render } from "./InfiniteLoading.vue?vue&type=template&id=55f37862&ts=true"
import script from "./InfiniteLoading.vue?vue&type=script&lang=ts"
export * from "./InfiniteLoading.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__